module.exports = __webpack_public_path__ + "img/redeem_form2_en.6b7c3f2d.png";